import Head from "components/Head"

export default function Privacy() {
  return (
    <div className="bg-gray-900">
      <Head
        title="Content Guidelines"
        description="Paragraph's content guidelines"
      />
      <div className="pt-12 sm:pt-16 lg:pt-24">
        <div className="px-4 mx-auto text-center max-w-7xl sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto space-y-2 lg:max-w-none">
            <p className="text-3xl font-extrabold text-white sm:text-4xl lg:text-5xl">
              Content Guidelines
            </p>
          </div>
        </div>
      </div>
      <div className="pb-12 mt-8 bg-gray-50 sm:mt-12 sm:pb-16 lg:mt-16 lg:pb-24">
        <div className="relative">
          <div className="absolute inset-0 bg-gray-900 h-3/4" />
          <div className="relative z-10 px-4 mx-auto max-w-7xl sm:px-6 lg:px-8"></div>
        </div>
        <div className="relative px-4 mx-auto mt-4 max-w-7xl sm:px-6 lg:px-8 lg:mt-5">
          <div className="max-w-md mx-auto lg:max-w-5xl prose prose-lg py-8">
            <p>Effective date: 07/01/2021</p>
            <p>
              Paragraph is a place for independent writing. We host and
              celebrate a diverse range of thought and discussion. The following
              guidelines outline what is and is not acceptable on Paragraph. We
              have the exclusive right to interpret and enforce these
              guidelines, although we may consult outside experts, research, and
              industry best practices in doing so. If you encounter content that
              may be in breach of these guidelines or have any questions about
              them, you can email us at tos@paragraph.xyz.
            </p>
            <p>
              If we determine that any content is in breach of these guidelines,
              we may remove it, hide it from public view, or impose other
              restrictions. This is an evolving document: we reserve the right
              to update these Content Guidelines at our discretion and without
              notice.{" "}
            </p>
            <p>
              Also, please note that we use SendGrid for email delivery, so all
              content delivered by email will be subject to{" "}
              <a href="https://www.twilio.com/legal/service-country-specific-terms/email">
                SendGrid's terms of service
              </a>{" "}
              in addition to the content guidelines described here.
            </p>
            <h2>Legal </h2>
            <p>
              Please respect people’s intellectual property and don’t infringe
              on their privacy or any other legal rights. Don’t publish anything
              that violates laws or regulations. You and you alone are
              responsible for the content you publish on Paragraph, and liable
              for any harm caused by the content you publish.
            </p>
            <h2>In General </h2>
            <p>
              We want Paragraph to be a safe place for discussion and
              expression. At the same time, we believe that critique and
              discussion of controversial issues are part of robust discourse,
              so we work to find a reasonable balance between these two
              priorities. In all cases, Paragraph does not allow harassment or
              threats.{" "}
            </p>
            <h2>Hate </h2>
            <p>
              Paragraph cannot be used to publish content or fund initiatives
              that incite violence based on protected classes. Offending
              behavior includes credible threats of physical harm to people
              based on their race, ethnicity, national origin, religion, sex,
              gender identity, sexual orientation, age, disability or medical
              condition.
            </p>
            <h2>Private information </h2>
            <p>
              You may not publish or post other people's private information
              (such as a personal phone number or home address) without their
              express authorization and permission. We also prohibit threatening
              to expose private information or incentivizing others to do so.
              The publication of publicly accessible information is not a
              violation of this policy.
            </p>
            <h2>Plagiarism</h2>
            <p>
              Do not publish any material that was written or created by someone
              else and claim it as your own.
            </p>
            <h2>Impersonation</h2>
            <p>
              We don’t allow impersonation, which includes posing as another
              person, brand, or organization. This applies to Paragraph itself:
              don’t use Paragraph’s name, logo, or trademark in any way that
              misrepresents the company or misleads others.{" "}
            </p>
            <h2>People restricted from making money on Paragraph</h2>
            <p>
              Paragraph’s payments are processed through Stripe, which excludes
              certain types of businesses from using their service. Please refer
              to the Stripe Service Agreement (see the US agreement here) and
              Stripe’s restricted businesses for more information about
              restricted business categories and practices. If you choose to use
              cryptocurrency instead of Stripe, there are no exclusion of
              businesses.
            </p>
            <h2>Harmful and illegal activities</h2>
            <p>
              We don’t allow content that promotes harmful or illegal
              activities, including material that advocates, threatens, or shows
              you causing harm to yourself, other people, or animals.
            </p>
            <h2>Spam and phishing</h2>
            <p>
              We are vehemently anti-spam and anti-phishing. If you are
              importing a mailing list from another platform, you are required
              to ensure it’s made up of people who explicitly opted-in to
              receive emails from your specific publication. Don’t add people to
              your mailing list without their consent, and don’t import your
              contacts list or social graphs. Similarly, you may not create
              publications for spamming or phishing purposes. Don’t post spam
              when interacting with others on Paragraph, such as in comments,
              discussion threads, or email replies.
            </p>
            <p>
              Paragraph is not an email marketing platform. We don’t permit
              publications that are set up with the sole purpose of advertising
              an external product or service, distributing offers and
              promotions, or similar activity.
            </p>
            <p>
              Paragraph is also not a place for blogspam. We don't permit
              posting content that is primarily intended to drive traffic to a
              third-party site.
            </p>
            <h2>Nudity, porn, erotica</h2>
            <p>
              We don’t allow porn or sexually exploitative content on Paragraph.
              We do allow depictions of nudity for artistic, journalistic, or
              related purposes, as well as erotic literature. However, we may
              hide this content from Paragraph’s discovery features, including
              search and on paragraph.xyz.{" "}
            </p>
            <h2>Comments</h2>
            <p>
              The philosophy behind these guidelines also applies to Paragraph
              readers. We believe that writers are responsible for moderating
              and managing their communities, but there are some occasions when
              we will review reports of readers’ comments to enforce these
              guidelines.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
